import React from 'react';

const Logo = props => {
  return (
    <img width="40" alt="Logo" src="/static/kclogo-white-blue.png" {...props} />
  );
};

export default Logo;
